import { Link } from 'react-router-dom';
import { LegalLayout } from '../../components/LegalLayout';

export function CGUPage() {
  return (
    <LegalLayout
      title="Conditions générales d'utilisation (CGU)"
      lead="Dernière mise à jour : juillet 2026 · Jeu Dezoom sur dezoom.eu"
    >
      <h2>1. Objet</h2>
      <p>
        Les présentes CGU régissent l'accès et l'utilisation du jeu en ligne{' '}
        <strong>Dezoom</strong>, édité par PrograGames (Florian Augeard). En accédant au jeu,
        tu acceptes ces conditions.
      </p>

      <h2>2. Éditeur</h2>
      <p>
        PrograGames — Florian Augeard, 49000 Angers, France.
        Contact :{' '}
        <a href="https://progragames.com/contact.html" target="_blank" rel="noopener noreferrer">
          progragames.com/contact
        </a>
        .
      </p>

      <h2>3. Accès au jeu</h2>
      <p>
        Dezoom est un jeu de devinettes photo dans le navigateur. Le défi du jour est gratuit.
        Le mode infini, l'arène classée et certaines fonctionnalités avancées nécessitent
        l'achat du mode premium (voir <Link to="/cgv">CGV</Link>). Une connexion Internet est requise.
      </p>

      <h2>4. Âge et capacité</h2>
      <p>
        Le jeu s'adresse aux personnes de <strong>16 ans et plus</strong>. Si tu es mineur,
        l'utilisation doit se faire avec l'autorisation d'un parent ou titulaire de l'autorité parentale.
      </p>

      <h2>5. Compte joueur</h2>
      <ul>
        <li>Tu peux jouer en <strong>invité</strong> ou créer un <strong>compte</strong> (email, pseudo).</li>
        <li>Tu es responsable de la confidentialité de ton accès (lien magique, session).</li>
        <li>Le pseudo doit être unique et ne pas porter atteinte aux droits de tiers.</li>
        <li>La progression (série, scores, Elo, ligues) est liée au compte connecté.</li>
      </ul>

      <h2>6. Fonctionnalités</h2>
      <ul>
        <li><strong>Défi du jour</strong> : une énigme officielle par jour, classement quotidien.</li>
        <li><strong>Mode infini</strong> (premium) : énigmes illimitées depuis la banque premium.</li>
        <li><strong>Arène</strong> (premium) : matchs classés best-of-5 avec classement Elo, sans limite de parties.</li>
        <li><strong>Amis</strong> : ajout par pseudo, défis entre amis premium.</li>
        <li><strong>Ligues</strong> : groupes privés avec énigmes premium quotidiennes et classement interne.</li>
      </ul>

      <h2>7. Règles de conduite</h2>
      <p>Il est interdit notamment de :</p>
      <ul>
        <li>Utiliser des bots, scripts ou outils automatisés pour jouer ou deviner ;</li>
        <li>Exploiter des bugs pour obtenir un avantage (merci de les signaler) ;</li>
        <li>Harceler d'autres joueurs via pseudo ou comportement ;</li>
        <li>Contourner les systèmes de score, Elo ou classement ;</li>
        <li>Usurper l'identité d'autrui ou de l'éditeur.</li>
      </ul>
      <p>PrograGames se réserve le droit de suspendre ou supprimer un compte en cas de manquement.</p>

      <h2>8. Contenu premium</h2>
      <p>
        L'accès premium est une <strong>licence d'utilisation numérique</strong> sur ton compte.
        Il n'a pas de valeur monétaire réelle et n'est ni transférable ni remboursable
        une fois activé, sauf obligation légale (voir <Link to="/cgv">CGV</Link>).
      </p>

      <h2>9. Propriété intellectuelle</h2>
      <p>
        Le jeu, ses énigmes, marques et contenus restent la propriété de PrograGames ou de ses concédants
        (photographes Pexels/Unsplash — voir <Link to="/credits">crédits photos</Link>).
      </p>

      <h2>10. Données personnelles</h2>
      <p>
        Le traitement des données est décrit dans la{' '}
        <Link to="/confidentialite">politique de confidentialité</Link>.
      </p>

      <h2>11. Responsabilité</h2>
      <p>
        Le jeu est fourni « en l'état ». PrograGames ne garantit pas un fonctionnement ininterrompu.
        Dans les limites autorisées par la loi, la responsabilité de l'éditeur est limitée aux dommages directs prouvés.
      </p>

      <h2>12. Droit applicable</h2>
      <p>
        Les présentes CGU sont soumises au <strong>droit français</strong>. En cas de litige,
        les tribunaux compétents seront déterminés selon les règles de droit commun,
        sous réserve des dispositions protectrices des consommateurs.
      </p>
    </LegalLayout>
  );
}
